import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  getPartCatalogList,
  createChangePartAnotherPart,
} from "../../services/LerCatalogService";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import Select from "react-select";
import {
  getPartGroupAllList,
  getPartLocationAllList,
  getPartSideAllList,
  getPartTypeAllList,
} from "../../services/PartTypeService";

const SwapPart = () => {
  const tableLengthList = ConfigDB.data.dataTableLength;
  const navigate = useNavigate();
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const location = useLocation();
  const LangData = localStorage.getItem("lng");
  const state = useLocation();
  const { t } = useTranslation();
  const [totalRecords, setTotalRecords] = useState(0);
  const [partList, setPartList] = useState([]);
  const [params, setParams] = useState({
    limit: tableLengthList[0],
    search: "",
    is_reload: false,
    company_id: companyId.company_id || 0,
    page: 1,
    catalog_name: "",
    part_type: "",
    part_location: "",
    part_group: "",
    part_side: "",
    number_of_car_doors: "",
    individual: "",
    depends_body_car: "",
    is_master_part: "",
  });
  const [filterData, setFilterData] = useState({
    catalog_name: "",
    part_type: "",
    part_location: "",
    part_group: "",
    part_side: "",
    number_of_car_doors: "",
    individual: "",
    depends_body_car: "",
    is_master_part: "",
  });
  const [show, setShow] = useState(false);
  const [partTypeList, setPartTypeList] = useState([]);
  const [partLocationList, setPartLocationList] = useState([]);
  const [partGroupList, setPartGroupList] = useState([]);
  const [partSideList, setPartSideList] = useState([]);
  const [modifySwapModal, setModifySwapModal] = useState(false);
  const [swapData, setSwapData] = useState(null);
  const [selectedId, setSelectedId] = useState("");
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);

  const handleRadioChange = (e) => {
    const selectedToId = parseInt(e.target.value);
    setSelectedId(e.target.value);
    setSwapData((prev) => ({
      ...prev,
      to_parts_catalog_id: selectedToId,
    }));
  };

  useEffect(() => {
    if (state.state) {
      setSwapData({
        parts_catalog_id: state.state.id,
        to_parts_catalog_id: "",
      });
    }
  }, [state]);

  const handleShowOpen = () => {
    setShow(true);
  };

  const handleShowClose = () => {
    setShow(false);
  };

  const handleCheckboxChangeIndividual = (e) => {
    setFilterData({
      ...filterData,
      individual: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangeDependsBodyCar = (e) => {
    setFilterData({
      ...filterData,
      depends_body_car: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangeIsMasterPart = (e) => {
    setFilterData({
      ...filterData,
      is_master_part: e.target.checked ? 1 : 0,
    });
  };

  useEffect(function () {
    getPartTypeAllList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].descriptionUK,
          });
        }

        setPartTypeList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    getPartLocationAllList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].descriptionUK,
          });
        }
        setPartLocationList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    getPartGroupAllList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].descriptionUK,
          });
        }
        setPartGroupList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    getPartSideAllList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].descriptionUK,
          });
        }
        setPartSideList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("searchValue");
      localStorage.removeItem("filterSwapData");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const storedSearch = localStorage.getItem("searchValue") || "";

    setParams((prevParams) => ({
      ...prevParams,
      search: storedSearch,
    }));
  }, [location.pathname]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
      localStorage.setItem("searchValue", e.target.value); // Save search to localStorage
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1; // ReactPaginate starts from 0, so we add 1
    }
    paramsObj.catalog_name = filterData.catalog_name;
    paramsObj.part_type = filterData.part_type;
    paramsObj.part_location = filterData.part_location;
    paramsObj.part_group = filterData.part_group;
    paramsObj.part_side = filterData.part_side;
    paramsObj.number_of_car_doors = filterData.number_of_car_doors;
    paramsObj.individual = filterData.individual;
    paramsObj.depends_body_car = filterData.depends_body_car;
    paramsObj.is_master_part = filterData.is_master_part;
    localStorage.setItem("filterSwapData", JSON.stringify(paramsObj));

    setShow(false);

    setParams(paramsObj);
  };

  useEffect(() => {
    const savedFilterData = localStorage.getItem("filterSwapData");
    if (savedFilterData) {
      const parsedFilterData = JSON.parse(savedFilterData);
      setParams((prev) => ({
        ...prev,
        ...parsedFilterData,
      }));
      setFilterData(parsedFilterData);
    }
  }, []);

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("filterSwapData"));
    if (savedData) {
      setFilterData({
        catalog_name: savedData?.catalog_name,
        part_type: savedData?.part_type,
        part_location: savedData?.part_location,
        part_group: savedData?.part_group,
        part_side: savedData?.part_side,
        number_of_car_doors: savedData?.number_of_car_doors,
        individual: savedData?.individual,
        depends_body_car: savedData?.depends_body_car,
        is_master_part: savedData?.is_master_part,
      });
    }
  }, []);

  const ResetModal = () => {
    setParams({
      limit: tableLengthList[0],
      page: 1,
      search: "",
      is_reload: false,
      company_id: companyId.company_id || 0,
      catalog_name: "",
      part_type: "",
      part_location: "",
      part_group: "",
      part_side: "",
      number_of_car_doors: "",
      individual: "",
      depends_body_car: "",
      is_master_part: "",
    });

    setFilterData({
      catalog_name: "",
      part_type: "",
      part_location: "",
      part_group: "",
      part_side: "",
      number_of_car_doors: "",
      individual: "",
      depends_body_car: "",
      is_master_part: "",
    });

    setShow(false);

    localStorage.removeItem("filterSwapData");
  };

  const fetchPartCatLog = () => {
    let data = { ...params };
    getPartCatalogList(data)
      .then((response) => {
        setPartList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(
    function () {
      let data = { ...params };
      fetchPartCatLog(data);
    },
    [params]
  );

  const handleSwapForm = (e) => {
    e.preventDefault();

    if (!selectedId) {
      toast.error(t("pc_toast_please_select_part"));
      return;
    }
    setIsModifyButtonLoad(true);
    let data = {
      parts_catalog_id: swapData.parts_catalog_id,
      to_parts_catalog_id: swapData.to_parts_catalog_id,
    };
    createChangePartAnotherPart(data)
      .then((response) => {
        toast.success(response.data.message);

        navigate("/part-catalog");
        setIsModifyButtonLoad(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsModifyButtonLoad(false);
      });
  };

  return (
    <div>
      <>
        <div>
          {/* Your existing content goes here */}
          <section className="content-header">
            <div className="container-fluid ">
              <div className="row mb-2 px-2">
                <div className="col-sm-6">{/* <h1>Part Catalog</h1> */}</div>
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid container-custom-height-new">
              <div className="row">
                <div className="col-md-12">
                  <div className="card fuelCard">
                    <div className="card-header">
                      <div
                        className="card-title m-0 float-left"
                        style={{ width: "50%" }}
                      >
                        <input
                          type="text"
                          className="form-control"
                          value={params.search}
                          onChange={(e) => handleParams(e, "search")}
                          placeholder={t("search")}
                        />
                      </div>

                      <div className="card-title m-0 float-right d-flex">
                        <div className="card-title-row">
                          <button
                            type="button"
                            className="btn-icon-text "
                            onClick={handleShowOpen}
                          >
                            <i className="bi bi-funnel"></i>Filter
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="vehicleThBg table-responsive table-responsive-vehicle">
                        <table className="table table-bordered rounded-table table table-striped table-hover">
                          <thead>
                            <tr>
                              <th style={{ width: "0%" }}></th>

                              <th style={{ width: "10%" }}>
                                {LangData === "pt"
                                  ? "Part Catalog Description"
                                  : LangData === "fr"
                                  ? "Part Catalog Description"
                                  : LangData === "es"
                                  ? "Part Catalog Description"
                                  : LangData === "it"
                                  ? "Part Catalog Description"
                                  : LangData === "de"
                                  ? "Part Catalog Description"
                                  : "Part Catalog Description"}
                              </th>

                              <th style={{ width: "10%" }}>{t("body_car")}</th>
                              <th style={{ width: "10%" }}>{t("car_doors")}</th>
                              <th style={{ width: "0%" }}>{t("percentage")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {partList
                              .filter(
                                (item) => item.id !== swapData?.parts_catalog_id
                              )
                              .map((item, index) => (
                                <tr key={item.id}>
                                  <td>
                                    <td>
                                      <input
                                        type="radio"
                                        name="part"
                                        value={item.id}
                                        checked={
                                          selectedId === item.id.toString()
                                        }
                                        onChange={handleRadioChange}
                                      />
                                    </td>
                                  </td>
                                  <td>
                                    {LangData === "pt"
                                      ? item.namePartPT
                                      : LangData === "fr"
                                      ? item.namePartFR
                                      : LangData === "es"
                                      ? item.namePartES
                                      : LangData === "it"
                                      ? item.namePartIT
                                      : LangData === "de"
                                      ? item.namePartDE
                                      : item.namePartEN}
                                  </td>
                                  <td>{item.dependsBodyCar}</td>
                                  <td>{item.numCarDoors}</td>
                                  <td>{item.percentage}</td>
                                </tr>
                              ))}
                            {partList && partList.length === 0 && (
                              <tr>
                                <td colSpan={5} className="text-center">
                                  {t("no_record_found")}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer clearfix">
              <div className="pagination pagination-sm m-0 float-right card-footer-part">
                <ReactPaginate
                  previousLabel={<i className="bi bi-chevron-double-left"></i>}
                  nextLabel={<i className="bi bi-chevron-double-right"></i>}
                  breakLabel={"..."}
                  pageCount={Math.ceil(totalRecords / params.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => handleParams(e, "pagination")}
                  forcePage={params.page - 1}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                />
              </div>
            </div>
          </section>
        </div>
        {/* )} */}
        <div className="row">
          <div className="col ms-2">
            <button
              type="button"
              className="back-btn"
              onClick={() => navigate("/part-catalog")}
            >
              <i className="bi bi-arrow-left"> </i> {t("back")}
            </button>
          </div>
          <div className="col">
            <div className="d-flex justify-content-end nxt-btn">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSwapForm}
              >
                {t("submit")} <i className="bi bi-check2"></i>
              </button>
            </div>
          </div>
        </div>

        <div
          className={`offcanvas offcanvas-end offcanvas-custom ${
            show ? "show" : ""
          }`}
          tabIndex="-1"
          id="staticBackdrop"
          aria-labelledby="staticBackdropLabel"
          style={{ visibility: show ? "visible" : "hidden" }}
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="staticBackdropLabel">
              Filter
            </h5>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleShowClose}
            ></button>
          </div>

          <div className="offcanvas-body offcanvas-body-custom">
            <div className="tab-content-canvas">
              <div className="row">
                <div className="col-sm-6">
                  <div className="Label-my">
                    Part Name
                    <input
                      className="form-control mt-2 input-search"
                      type="text"
                      value={filterData?.catalog_name || ""}
                      onChange={(e) => {
                        setFilterData((prev) => ({
                          ...prev,
                          catalog_name: e.target.value,
                        }));
                      }}
                      maxLength={50}
                      placeholder={t("part_name")}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="Label-my">
                    Part Type{" "}
                    <Select
                      className="my-select-v mt-2"
                      options={partTypeList}
                      value={
                        partTypeList.find(
                          (item) => item.value == filterData.part_type
                        ) || null
                      }
                      onChange={(selectedOption) =>
                        setFilterData({
                          ...filterData,
                          part_type: selectedOption ? selectedOption.value : "",
                        })
                      }
                      isSearchable={true}
                      isClearable={true}
                      placeholder={"Select Part Type"}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="Label-my">
                    Part Location{" "}
                    <Select
                      className="my-select-v mt-2"
                      options={partLocationList}
                      value={
                        partLocationList.find(
                          (item) => item.value == filterData.part_location
                        ) || null
                      }
                      onChange={(selectedOption) =>
                        setFilterData({
                          ...filterData,
                          part_location: selectedOption
                            ? selectedOption.value
                            : "",
                        })
                      }
                      isSearchable={true}
                      isClearable={true}
                      placeholder={"Select Part Location"}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="Label-my">
                    Part Group{" "}
                    <Select
                      className="my-select-v mt-2"
                      options={partGroupList}
                      value={
                        partGroupList.find(
                          (item) => item.value == filterData.part_group
                        ) || null
                      }
                      onChange={(selectedOption) =>
                        setFilterData({
                          ...filterData,
                          part_group: selectedOption
                            ? selectedOption.value
                            : "",
                        })
                      }
                      isSearchable={true}
                      isClearable={true}
                      placeholder={"Select Part Group"}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="Label-my">
                    Part Side{" "}
                    <Select
                      className="my-select-v mt-2"
                      options={partSideList}
                      value={
                        partSideList.find(
                          (item) => item.value == filterData.part_side
                        ) || null
                      }
                      onChange={(selectedOption) =>
                        setFilterData({
                          ...filterData,
                          part_side: selectedOption ? selectedOption.value : "",
                        })
                      }
                      isSearchable={true}
                      isClearable={true}
                      placeholder={"Select Part Side"}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="Label-my">
                    Number of car doors
                    <input
                      className="form-control mt-2 input-search"
                      type="number"
                      value={filterData?.number_of_car_doors || ""}
                      onChange={(e) => {
                        setFilterData((prev) => ({
                          ...prev,
                          number_of_car_doors: e.target.value,
                        }));
                      }}
                      maxLength={50}
                      placeholder={t("pc_number_of_car_doors")}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                </div>{" "}
                <div className="col-md-4" style={{ marginTop: "10px" }}>
                  <div
                    className="Label-my"
                    style={{
                      whiteSpace: "nowrap",
                      paddingTop: "0px",
                    }}
                  >
                    <div className="input-div">
                      <div className="form-check">
                        <input
                          className="my-checkbox-1 form-check-input"
                          type="checkbox"
                          checked={filterData.individual === 1}
                          onChange={handleCheckboxChangeIndividual}
                        />
                        <label className="form-check-label pl-6">
                          {t("individual")}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-5" style={{ marginTop: "10px" }}>
                  <div
                    className="Label-my"
                    style={{
                      whiteSpace: "nowrap",
                      paddingTop: "0px",
                    }}
                  >
                    <div className="input-div">
                      <div className="form-check">
                        <input
                          className="my-checkbox-1 form-check-input"
                          type="checkbox"
                          checked={filterData.depends_body_car === 1}
                          onChange={handleCheckboxChangeDependsBodyCar}
                        />
                        <label className="form-check-label pl-6">
                          {t("depends_body_car")}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3" style={{ marginTop: "10px" }}>
                  <div
                    className="Label-my"
                    style={{
                      whiteSpace: "nowrap",
                      paddingTop: "0px",
                    }}
                  >
                    <div className="input-div">
                      <div className="form-check">
                        <input
                          className="my-checkbox-1 form-check-input"
                          type="checkbox"
                          checked={filterData.is_master_part === 1}
                          onChange={handleCheckboxChangeIsMasterPart}
                        />
                        <label className="form-check-label pl-6">
                          {t("is_master_part")}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="offcanvas-footer">
            <div className="d-flex justify-content-around">
              <button
                style={{ marginTop: "9px", display: "flex" }}
                type="button"
                className="btn  btn-primary btn-filter"
                onClick={(e) => handleParams(e)}
              >
                <span className="ms-1">Search</span>
              </button>
              <button
                style={{ marginTop: "9px", display: "flex" }}
                type="button"
                className="btn  btn-primary ms-1 btn-filter"
                onClick={ResetModal}
              >
                <span className="ms-1 ">Reset</span>
              </button>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default SwapPart;
